import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
    basename: ''
});

// 改写history.push方法，在state中加入from参数
const fnHistoryPush = history.push;
history.push = (path, ...params) => {
    if (typeof path === 'string') {
        fnHistoryPush(path, {
            ...params,
            from: {
                hash: history.location.hash,
                pathname: history.location.pathname,
                search: history.location.search
            }
        });
    } else {
        fnHistoryPush(
            {
                ...path,
                state: {
                    ...path.state,
                    from: {
                        hash: history.location.hash,
                        pathname: history.location.pathname,
                        search: history.location.search
                    }
                }
            },
            ...params
        );
    }
};

export default history;
